<template>
    <div class="page article-info">
        <h1>Article information</h1>

    </div>
</template>


<script>
    // The ISSN-L lookup that used to live here (api.unpaywall.org/issn_ls) was
    // retired 2026-09-18; the page never rendered it anyway.
    export default {
        name: "ArticleInfo",
        metaInfo: {
            title: "Article information"
        }
    }
</script>

<style scoped>

</style>